import { useState, useEffect, useMemo } from "react";
import SoftBox from "components/SoftBox";
import CreateModal from "./components/CreateModal";
import AppData from "./components/data-tables/data/dataTableData";
import Loader from "examples/Loader";
import "./style.css";

function Accounts() {
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");

  // Debounce the raw input into a separate value so typing feels instant;
  // only the debounced value drives the query key (and its refetch).
  useEffect(() => {
    const handler = setTimeout(() => setDebouncedSearch(searchTerm), 1000);
    return () => clearTimeout(handler);
  }, [searchTerm]);

  const { dataTableData, handleRefresh, loader, accounts, page, setPage } = AppData(debouncedSearch);

  return loader ? (
    <Loader />
  ) : (
    <div className="container-alignment">
      <SoftBox p={3} alignItems="center">
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <h1 className="headingpage-branding" style={{ marginTop: "30px" }}>
            Users
          </h1>
          <CreateModal accounts={accounts} handleRefresh={handleRefresh} setPage={setPage} />
        </div>
        <div className=" d-flex justify-content-between w-100" style={{ margin: "30px 0" }}>
          <div className="w-50 position-relative">
            <span className="fa-fa-search position-absolute" style={{ top: "17px" }}>
              {/* SVG Icon */}
            </span>
            <input
              type="text"
              className="inputsearch"
              placeholder="Search User ..."
              value={searchTerm}
              style={{ fontSize: "18px" }}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          {/* <div className="w-50 text-end">
            <CreateModal handleRefresh={handleRefresh} accounts={accounts} />
          </div> */}
        </div>
        <NormalTable
          columns={dataTableData.columns}
          rows={dataTableData.rows || []}
          totalpages={dataTableData.totalpage}
          page={page}
          onPageChange={setPage}
        />
      </SoftBox>
    </div>
  );
}

export default Accounts;

const NormalTable = ({ columns, rows, totalpages, page, onPageChange }) => {
  if (!Array.isArray(rows)) {
    return <Loader />;
  }

  const totalPages = totalpages;
  const maxButtonsToShow = 5; // Number of pagination buttons to display at a time
  const currentItems = rows;
  const currentPage = page;

  const handlePageChange = (pageNumber) => {
    if (page !== pageNumber) {
      onPageChange(pageNumber);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  // Calculate start and end of pagination buttons
  const startPage = useMemo(
    () => Math.max(currentPage - Math.floor(maxButtonsToShow / 2), 1),
    [currentPage]
  );
  const endPage = useMemo(
    () => Math.min(startPage + (maxButtonsToShow - 1), totalPages),
    [startPage, totalpages, page]
  );

  return (
    <>
      <div className="d-flex w-100">
        {columns.map((column, index) => (
          <div className="margin-left-20px p-20-px w-32-per text-left" key={index}>
            {column.Header}
          </div>
        ))}
      </div>
      <div>
        {currentItems.map((row, rowIndex) => (
          <div key={rowIndex} className="equalheight d-flex w-100 tablebody-row">
            {columns.map((column, colIndex) => (
              <div key={colIndex} className="p-20-px text-black text-bold text-left w-32-per">
                {row[column.accessor]}
              </div>
            ))}
          </div>
        ))}
      </div>
      {/* Pagination Controls */}
      <div style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
        <button
          onClick={handlePreviousPage}
          disabled={currentPage === 1}
          style={{
            padding: "8px 16px",
            margin: "0 5px",
            backgroundColor: "white",
            color: "black",
            border: "1px solid black",
            borderRadius: "4px",
            cursor: currentPage === 1 ? "not-allowed" : "pointer",
            opacity: currentPage === 1 ? 0.6 : 1,
          }}
        >
          Previous
        </button>

        {startPage &&
          endPage &&
          [...Array(endPage - startPage + 1)].map((_, index) => {
            const pageNumber = startPage + index;
            return (
              <button
                key={pageNumber}
                onClick={() => handlePageChange(pageNumber)}
                style={{
                  padding: "8px 16px",
                  margin: "0 5px",
                  backgroundColor: pageNumber == page ? "black" : "white",
                  color: pageNumber == page ? "white" : "black",
                  border: pageNumber == page ? "1px solid white" : "1px solid black",
                  borderRadius: "4px",
                  cursor: "pointer",
                }}
              >
                {pageNumber}
              </button>
            );
          })}

        <button
          onClick={handleNextPage}
          disabled={currentPage === totalPages}
          style={{
            padding: "8px 16px",
            margin: "0 5px",
            backgroundColor: "white",
            color: "black",
            border: "1px solid black",
            borderRadius: "4px",
            cursor: currentPage === totalPages ? "not-allowed" : "pointer",
            opacity: currentPage === totalPages ? 0.6 : 1,
          }}
        >
          Next
        </button>
      </div>
    </>
  );
};
